import { render, staticRenderFns } from "./AuditoriaComponent.vue?vue&type=template&id=0fc6b7a2"
import script from "./AuditoriaComponent.vue?vue&type=script&lang=js"
export * from "./AuditoriaComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports